export const SET_FIELD = 'DPT_DATA_PROCESSING/SET_FIELD';
export const FETCH_DATA = 'DPT_DATA_PROCESSING/FETCH_DATA';
export const FETCH_DATA_SUCCESS = 'DPT_DATA_PROCESSING/FETCH_DATA_SUCCESS';
export const FETCH_DATA_ERROR = 'DPT_DATA_PROCESSING/FETCH_DATA_ERROR';
export const SAVE = 'DPT_DATA_PROCESSING/SAVE';
export const SAVE_SUCCESS = 'DPT_DATA_PROCESSING/SAVE_SUCCESS';
export const SAVE_ERROR = 'DPT_DATA_PROCESSING/SAVE_ERROR';
export const FETCH_ELEMENT = 'DPT_DATA_PROCESSING/FETCH_ELEMENT';
export const FETCH_ELEMENT_SUCCESS = 'DPT_DATA_PROCESSING/FETCH_ELEMENT_SUCCESS';
export const FETCH_ELEMENT_ERROR = 'DPT_DATA_PROCESSING/FETCH_ELEMENT_ERROR';
export const SET_ACTIVE_PAGE = 'DPT_DATA_PROCESSING/SET_ACTIVE_PAGE';
export const RESET_FORM = 'DPT_DATA_PROCESSING/RESET_FORM';